import React, { useState, useEffect } from "react";
import IntroText from "../components/IntroText";
import { Helmet } from "react-helmet";
import axios from "axios";
import { apiUrl } from "../utils/urls";

function TextGenerator() {
  const [result, setResult] = useState(null);
  const [search, setSearch] = useState("");
  const [instaResults, setInstaResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetch, setIsFetch] = useState(false);
  const [postLimit, setPostLimit] = useState(20);

  // getSearch
  const getSearch = (value) => {
    setSearch(value);
  };

  // * * * get Results
  const getResults = () => {
    setIsLoading(true);
    setResult(null);
    axios
      .post(`${apiUrl}/generator`, {
        text: search,
      })
      .then((res) => {
        const searchResults = res.data;
        if (searchResults.success) {
          setResult(searchResults.data.output);
        } else {
          setResult(null);
        }
        // console.log("search results >>>", searchResults);
        setIsFetch(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsFetch(false);
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (isFetch) {
      // getInstaramhash();
      getResults();
    }
  }, [isFetch]);

  // * * * handleFetch
  const handleFetch = (value) => {
    // console.log("handle", value);
    setIsFetch(value);
  };
  return (
    <div>
      <div className="container">
        <IntroText
          search={search}
          getSearch={getSearch}
          isLoading={isLoading}
          isFetch={isFetch}
          handleFetch={handleFetch}
        />
      </div>
      <div className="container">
        {result && (
          <div className="mt-12 pb-12">
            <h1>
              <strong>Result: </strong> {result}
            </h1>
          </div>
        )}
      </div>
    </div>
  );
}

export default TextGenerator;
